export type TradingMallExchanges = "NSE" | "BSE";

export const allowedRoutes: (string | RegExp)[] = [ "/investments/stock-and-trading", "/investments/upcoming-ipo", /^\/investments\/[a-zA-Z0-9-]+-share-price$/]

export const InvestmentConstants = {
  EXCHANGES: {
    NSE: "nse",
    BSE: "bse",
  },
};
